<template>
  <v-container class="fill-height" fluid>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" class="display-4 info--text text-center">
        404
      </v-col>
      <v-col cols=12 class="subtitle-1 grey--text text-center">
        Nu am găsit pagina pe care ai căutat-o.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  export default {
    mounted() {
      document.title = '404 - Page not found.';
    }
  }


</script>